<template>
  <div
    :class="['copy-btn' + props.index, 'copyBtnBox']"
    :data-clipboard-text="props.text"
    @click="copyText"
  >
    {{ props.text }}
    <van-icon v-if="copied" name="completed-o" size="20" color="#2bb92b" />
    <img
      v-else
      src="../assets/images/shippingCommission/copy.png"
      class="copy"
    />
    <!--    <van-icon-->
    <!--      v-else-->
    <!--      name="description-o"-->
    <!--      :color="'rgba(147,147,147,0.75)'"-->
    <!--      size="15"-->
    <!--    />-->
    <!--    <van-icon name="completed-o" />-->
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import ClipboardJS from 'clipboard'
import { showToast } from 'vant'
const props = defineProps<{
  text: string
  index: number
}>()

const copied = ref(false)
let clipboard: any

onMounted(() => {
  clipboard = new ClipboardJS('.copy-btn' + props.index)
  clipboard.on('success', () => {
    console.log('复制成功')
    showToast({ message: 'copy', duration: 500 })
    copied.value = true
    setTimeout(() => (copied.value = false), 500)
  })
  clipboard.on('error', () => {
    showToast({ message: 'copy failed', duration: 500 })
  })
})
onUnmounted(() => {
  clipboard?.destroy()
})
</script>

<style scoped lang="less">
.copy-btn {
  cursor: pointer;
  font-size: 13px;
}
.copy-btn:disabled {
  background: #2bb92b;
  cursor: not-allowed;
}

.copyBtnBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  .copy {
    width: 20px;
    height: 20px;
  }
}
</style>
